import { Stack } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { MessageResponse } from "../../../api";
import CustomerContext from "../../contexts/CustomerContext";
import SnackbarContext from "../../contexts/SnackbarContext";
import ApiWrapper from "../../wrappers/ApiWrapper";
import MessageDetailCard from "./elements/MessageDetailCard";
import MessagesOverviewCard from "./elements/MessagesOverviewCard";
import useDebounce from "../../hooks/useDebounce";

const PostBox = () => {
  const api = new ApiWrapper().messageControllerApi();
  const { customerNumber } = useContext(CustomerContext);
  const { handleHttpError } = useContext(SnackbarContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [messages, setMessages] = useState<MessageResponse[]>();
  const [selectedMessage, setSelectedMessage] = useState<number>(-1);
  const [currentPageNumber, setCurrentPageNumber] = useState<number>(0);

  const handleLoad = (pageNumber = 0, pageLimit = 25): void => {
    if (customerNumber) {
      api
        .getAllMessages(customerNumber, pageNumber, pageLimit)
        .then((res) => {
          console.log(res);

          setMessages([...(messages || []), ...res.data]);
          setCurrentPageNumber(pageNumber + 1);
        })
        .catch(handleHttpError)
        .finally(() => {
          setLoading(false);
          setLoadingMore(false);
        });
    }
  };

  useEffect(() => {
    let isApiSubscribed = true;

    if (isApiSubscribed && customerNumber) {
      handleLoad();
    }

    if (isApiSubscribed && customerNumber) {
      overviewCardRef.current?.addEventListener("scroll", handleLoadMore);
    }

    return () => {
      isApiSubscribed = false;
      overviewCardRef.current?.removeEventListener("scroll", handleLoadMore);
    };
  }, [customerNumber]);

  /* START LOAD MORE: The following lines all relate to loading additional messages via infinite scrolling */
  const [loadingMore, setLoadingMore] = useState<boolean>(false);

  const overviewCardRef = useRef<HTMLElement>(null);
  const currentPageRef = useRef(currentPageNumber);

  const debouncedLoading = useDebounce(loadingMore, 500); // Adjust the delay as needed

  const handleLoadMore = (e: Event): void => {
    const overviewCardElement: unknown = e.target;

    const reachedBottom =
      (overviewCardElement as HTMLElement).scrollTop ===
      (overviewCardElement as HTMLElement).scrollHeight -
        (overviewCardElement as HTMLElement).offsetHeight +
        2;

    if (!loading && reachedBottom) {
      setLoadingMore(true);
    }
  };

  useEffect(() => {
    currentPageRef.current = currentPageNumber;
  }, [currentPageNumber]);

  useEffect(() => {
    if (debouncedLoading) {
      handleLoad(currentPageRef.current);
    }
  }, [debouncedLoading]);
  /* END LOAD MORE */

  useEffect(() => {
    console.log(messages);
  }, [messages]);

  return (
    <Stack direction="row" sx={{ position: "relative" }}>
      <MessagesOverviewCard
        innerRef={overviewCardRef}
        loading={loading}
        loadingMore={loadingMore}
        loadMoreCallback={() => setLoadingMore(true)}
        setSelectedMessage={setSelectedMessage}
        selectedMessage={selectedMessage}
        messages={messages}
      />
      {messages && messages[selectedMessage] && (
        <MessageDetailCard
          loading={loading}
          selectedMessage={messages && messages[selectedMessage]}
        />
      )}
    </Stack>
  );
};

export default PostBox;
